import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const MODEL_FAMILY_CREATE_RESOURCE = "model-family" as const;
export const MODEL_FAMILY_CREATE_API_PATH = `/v1/${MODEL_FAMILY_CREATE_RESOURCE}` as const;

export type ModelFamilyCreateBody =
  paths[typeof MODEL_FAMILY_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type ModelFamilyCreateInput = ModelFamilyCreateBody;
export type ModelFamilyCreateResponse =
  paths[typeof MODEL_FAMILY_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useModelFamilyCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<ModelFamilyCreateResponse, Error, ModelFamilyCreateInput>({
    mutationFn: async (data: ModelFamilyCreateInput) => {
      const response = await alphartisApiAxios.post<ModelFamilyCreateResponse>(MODEL_FAMILY_CREATE_API_PATH, data);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MODEL_FAMILY_CREATE_RESOURCE],
      });
    },
  });
};
